<script type="text/javascript">
    // 定义一些公共的属性和方法
    const imgUrl = 'https://img.dianpiaobao.com/'
    // const oaurl = '//api.dianpiaobao.com/'

    // const oaurl = '//api.dianpiaobao.com/'
    // const imgUrls = '//api.dianpiaobao.com'
    // let newapi='//m.fee.api.dianpiaobao.com'
    // let titurl='//apispassist.dianpiaobao.com'
    // let dturl='//oaapi.dianpiaobao.com'
    // let dpburl='//dpb.api.dianpiaobao.com/'


    const oaurl = '//api.borntrust.com.cn/'
    const imgUrls = '//api.borntrust.com.cn'
    let newapi='//m.fee.api.borntrust.com.cn'
    let titurl='//api.spassist.borntrust.com.cn'
    let dturl='//oaapi.borntrust.com.cn'
    let dpburl='//dpb.api.borntrust.com.cn/'
    let zdyurl = 'https://api.dianpiaobao.com/'
    let withurl = 'https://api.with-ex.net'
    // let withurl = 'http://localhost:30000'
    function commonFun() {
        console.log("公共方法")
    }
    // 暴露出这些属性和方法
    export default {
        imgUrl,
        commonFun,
        oaurl,
        imgUrls,
        newapi,
        titurl,
        dturl,
        dpburl,
        zdyurl,
        withurl
    }
</script>


// WEBPACK FOOTER //
// src/common.vue